module.exports = __webpack_public_path__ + "static/media/explainer.71db2bf3.webp";